//菜单：币别管理
import React from 'react'
import Manager from '../../public/components/Manager'
import CurrencyDiv from './CurrencyDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('币别', props => <CurrencyDiv {...props} id={-1} onSave={refreshPage} />)
        },
    ],
    columns: [
        { _text: '币别', field: 'CurrencyName', minWidth: 150, flex: 1 },
        { _text: '本币', field: 'LocalCurrency', minWidth: 150, },
        { _text: '当前汇率', field: 'ExchangeRate', minWidth: 150, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('币别', props => <CurrencyDiv {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />